import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import logo from '../img/logo.png';
import { Helmet } from 'react-helmet';
import { themes } from '../context/ThemesList';
import axios from 'axios';
import { FaSpinner } from 'react-icons/fa';
import theme1 from '../img/theme1.jpg';
import NavBar from './NavBar';
import translations from '../translations';

function ChangeDesign() {
  const { id } = useParams();
  const [loading, setLoading] = useState(true);
  const [userTheme, setUserTheme] = useState('');
  const [language, setLanguage] = useState(localStorage.getItem('language') || 'en');
  const t = translations[language];

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/kad/${id}`);
        const data = response.data;

        setUserTheme(data.theme);
        console.log(data.theme);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchData();
  }, [id]); 

  const handlePreview = (theme) => {
    window.open(`/invite/${id}/theme${theme}/change-design`, '_blank');
  };
  
  const handleConfirmAndUpdate = async (theme) => {
    const confirmed = window.confirm(t.useThisDesign);

    const themeName = `theme${theme}`;
    if (confirmed) {
      try {
        const response = await axios.put(`${process.env.REACT_APP_API_BASE_URL}/update-cards/${id}`, {
          // Pass the necessary data to update (modify based on your API's needs)
          theme: themeName,
        });

        if (response.status === 200) {
          alert(t.designUpdatedSuccessfully);
          window.location.reload(); // Reloads the page
        } else {
          alert(t.failedToUpdateDesign);
        }
      } catch (error) {
        console.error('Error updating the theme:', error);
        alert(t.errorUpdatingDesign);
      }
    }
  };
  return (
    <div>
      {loading ? ( 
          <div className="fixed inset-0 flex flex-col items-center justify-center space-y-5">
            <FaSpinner className="text-4xl text-black animate-spin" />
            <img src={logo} alt="Logo" className="h-10 mb-4" />
          </div>
        ) : (
        <div>
          <NavBar />
          <div className='pt-28 px-4'>
            <h1 className="text-xl font-bold mb-4">{t.currentDesign}</h1>
            <div className="w-1/2 md:w-1/5 rounded shadow-lg my-4">
              <a
                href={`/invite/${id}`}
                target="_blank">
                  <img 
                    src={require(`../img/${userTheme}.jpg`)}
                  />
              </a>
            </div>
          </div>
          <div className="py-14 px-4">
            <h1 className="text-xl font-bold">{t.selectDesigns}</h1>
            <div className="flex flex-wrap">
              {themes.map((theme) => (
                <div key={theme.id} className="w-1/2 md:w-1/5 p-2 md:p-4">
                  <div className="max-w-sm rounded overflow-hidden shadow-lg my-4">
                    <img 
                      src={theme.image} 
                      alt={theme.title} 
                      className="w-full"
                      loading="lazy"
                    />
                  </div>
                  <div className='flex items-center justify-center space-x-2'>
                    <button className='btn-secondary text-sm p-1 w-full rounded-lg' onClick={() => handlePreview(theme.id)}>{t.preview}</button>
                    <button className='btn-primary text-sm p-1 w-full rounded-lg' onClick={() => handleConfirmAndUpdate(theme.id)}>{t.select}</button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
        )
      }
    </div>
  )
}

export default ChangeDesign